/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Carta de presentacion para incluir en la candidatura. El alumno tiene varias. El titulo solo lo ve el alumno. [P_A_24]
 * @export
 * @interface CandidateLetter
 */
export interface CandidateLetter {
    /**
     * 
     * @type {number}
     * @memberof CandidateLetter
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CandidateLetter
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateLetter
     */
    text?: string;
}

export function CandidateLetterFromJSON(json: any): CandidateLetter {
    return CandidateLetterFromJSONTyped(json, false);
}

export function CandidateLetterFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateLetter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function CandidateLetterToJSON(value?: CandidateLetter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'text': value.text,
    };
}


